module.exports = __webpack_public_path__ + "img/8.e76325f7.png";